class Env {
	/** Enable debug logging */
	get HASHNODE_DEBUG() {
		return Boolean(process.env.HASHNODE_DEBUG ?? false)
	}
}

export const env = new Env()
